import { abilitiesPlugin } from "@casl/vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import FloatingVue from "floating-vue";
import { createPinia } from "pinia";
import { createApp } from "vue";
import VueFeather from "vue-feather";
import Toast from "vue-toastification";

import App from "./App.vue";
import { setSentryInstance } from "./composables/useSentry";
import router from "./router";
import { SentryNode } from "./services/sentry";
import { apolloClient } from "./utils/apollo";
import ability from "./utils/casl/ability";

import "vue-toastification/dist/index.css";
import "@app/core/style.css";

import "./index.scss";
import "floating-vue/dist/style.css";

const pinia = createPinia();
const app = createApp(App);

export const sentryNode = new SentryNode(app, router);
sentryNode.init();
app.provide("$sentry", sentryNode);

setSentryInstance(sentryNode);

// NEED TO FIXED ISSUE WITH TABLE SCROLLING
FloatingVue.options.strategy = "fixed";

app.provide(DefaultApolloClient, apolloClient);

app
  .use(router)
  .use(pinia)
  .use(FloatingVue)
  .use(Toast, {
    maxToasts: 5,
  })
  .use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
  .component("feather-icon", VueFeather)
  .mount("#app");
